import goalsSrc from '@common/assets/images/about-me/goals/goals_sm.jpg';
import individualitySrc from '@common/assets/images/about-me/individuality/individuality_sm.jpg';
import interestSrc from '@common/assets/images/about-me/interests/interests_sm.jpg';
import qualitiesSrc from '@common/assets/images/about-me/personal-qualities/personal-qualities_sm.jpg';
import strengthsSrc from '@common/assets/images/about-me/strengths/strengths_lg.jpg';
import { getRoute } from '@common/constants/CampusRoutes';
import { AboutPageSectionType } from '@common/modules/Report/types';

const AboutPageSections: AboutPageSectionType[] = [
	{
		title: 'report.aboutMe.strengths',
		areaName: 'strengths',
		href: getRoute(['REPORT', 'ABOUT', 'STRENGTHS']),
		imageSrc: strengthsSrc,
		isPrimary: true,
	},
	{
		title: 'report.aboutMe.personalityQualities',
		areaName: 'qualities',
		href: getRoute(['REPORT', 'ABOUT', 'QUALITIES']),
		imageSrc: qualitiesSrc,
	},
	{
		title: 'report.aboutMe.interests',
		areaName: 'interests',
		href: getRoute(['REPORT', 'ABOUT', 'INTERESTS']),
		imageSrc: interestSrc,
	},
	{
		title: 'report.goals.main',
		areaName: 'goals',
		href: getRoute(['REPORT', 'ABOUT', 'GOALS']),
		imageSrc: goalsSrc,
	},
	{
		title: 'report.individuality.main',
		areaName: 'individuality',
		href: getRoute(['REPORT', 'ABOUT', 'INDIVIDUALITY']),
		imageSrc: individualitySrc,
	},
];

export default AboutPageSections;
